import { EntityBase } from './EntityBase';
import { Material } from './Material';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialCompositionDescription extends EntityBase {

    /// <code> Place custom code between <code> tags

    /// </code>

    // Generated code. Do not place code below this line.
    materialCompositionDescriptionId: number;
    materialId: number;
    materialCompositionName: string;
    comments: string;
    created: Date;
    createdUser: string;
    modified: Date;
    modifyUser: string;
    rowVersion: number;
    material: Material;
}
